//import { Balls } from './balls.js';
import { FigAnim } from './figanim.js';
import smoothscroll from 'smoothscroll-polyfill';
export class ScrChecker {
    constructor() {
        this.inviewElems = []; //inviewで効果をつける要素を登録する
        this.showPos1 = 0;
        this.showPos2 = 0;

        this.fig1;
    }
    setProps(el, props) {
        for (let key in props) {
            el.style.setProperty('--' + key, props[key]);
        }
    };
    clamp(v, min, max) {
        return min > v ? min : max < v ? max : v;
    }
    round(n) {
        return Math.round(n * 10000) / 10000;
    }

    calcElementOffsetY(elem) {
        let container = window;

        let parentElem;
        if (elem.parentElement) {
            parentElem = elem.parentElement;
        }
        let target = parentElem;

        // ページ全体に対するY座標を計算
        let numY = 0;
        do {
            numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
            target = target.offsetParent;
            //console.log(target);
        } while (target && target !== container); //要素のcontainerに対するY座標

        return numY;
    }

    figAnim1(elem){
        //console.log(elem);
        elem.classList.add('fig-anim-started');
        this.fig1 = new FigAnim(elem);
        this.fig1.play();
    }

    onUpdate() {

        //console.log('scroll onUpdate');

        //ウインドウ情報 ie11未対応
        //let windowWidth = window.innerWidth;
        //let windowHeight = window.innerHeight;
        //let windowOffsetY = window.scrollY;

        //ウインドウ情報など ie11対応
        let windowLeft = (window.screenLeft || window.screenX || 0);
        let windowTop = (window.screenTop || window.screenY || 0);
        let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);
        let windowScrollY = window.scrollY || window.pageYOffset;
        let windowScrollX = window.scrollX || window.pageXOffset;


        //console.log(windowScrollY);
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        if (windowScrollY > windowHeight) {
            this.body.classList.add('scrolled-windowheight');
        } else {
            this.body.classList.remove('scrolled-windowheight');
        }

        

        


        // ===========
        // indexページ: OP切り替え
        if (document.getElementById('concept-scroller') && this.body.classList.contains('loaded')) {
            let conceptState = 0;

            // スクロール要素 全体
            let conceptScrollChecker = document.getElementById('concept-scroller');

            // スクロール要素 実体
            let conceptScrolledElems = conceptScrollChecker.querySelectorAll('.js-concept-scroller');

            // 判定
            [].forEach.call(conceptScrolledElems, (elem) => {
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離

                // 切り替えタイミング ウインドウ上端から
                let showPos = windowHeight * 0;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0; //pc
                }

                // 何番目を表示するか
                if (y < showPos) {
                    conceptState += 1;
                }

                // ただしスクロール100以下はconcept開始前状態に
                if(windowScrollY < 100){
                    this.body.classList.remove('concept-start');
                    conceptState = 0;
                }
            });
            if(conceptState < 0) {
                conceptState = 0;
            }

            let concept = document.querySelector('.index-concept');
            concept.classList.remove('concept-0');
            concept.classList.remove('concept-1');
            concept.classList.remove('concept-2');
            concept.classList.remove('concept-3');
            concept.classList.remove('concept-4');
            concept.classList.remove('concept-5');
            concept.classList.add('concept-'+(conceptState - 1));
            
            //console.log(`class name: concept-` + (conceptState - 1) + `, conceptState=${conceptState}`);
            

           

            //-----------
            // concept-0, balls
            if(conceptState == 1){
                this.body.classList.add('concept-start');
                document.getElementById('cursor').classList.remove('cursor--xl');

                if(document.getElementById('conceptCanvas')){
                    if(this.body.classList.contains('flg-concept-0')){
                        //二度目の再生
                    }else{
                        this.conceptCanvas.play();
                    }
                }
            }

            //-----------
            // concept-3, bg3, スクロール
            let bg1 = document.querySelector('.bg1');
            let bg2 = document.querySelector('.bg2');
            let bg3 = document.querySelector('.bg3');
            let bg4 = document.querySelector('.bg4');

            let circleContainer = document.querySelector('.cover-opening-circle__circle');//輪っか

            let scrollers = document.querySelectorAll('.js-concept-scroller-container .js-concept-scroller');

            //スクローラー位置: baseY0,baseY3は文字表示タイミングに使う
            let baseY0 = scrollers[0].getBoundingClientRect().top;
            let baseY1 = scrollers[1].getBoundingClientRect().top;
            let baseY2 = scrollers[2].getBoundingClientRect().top;
            let baseY3 = scrollers[3].getBoundingClientRect().top;

            //console.log(`baseY1=${baseY1}, baseY2=${baseY2}, baseY3=${baseY3}`);

            // 黄色の背景
            let baseY3forBg = -1*windowHeight + scrollers[3].getBoundingClientRect().top;
            let baseYClamp = this.clamp(baseY3forBg, -1.5*windowHeight, windowHeight);
            let props3 = {
                'pos-y': baseYClamp,
            }
            this.setProps(bg3, props3);
            
            // 惑星の輪っか
            circleContainer.classList.remove('mode-2');
            circleContainer.classList.remove('mode-3');
            if(baseY1 < -200 ){
                circleContainer.classList.add('mode-3');
            }else if(baseY1 < 0 ){
                circleContainer.classList.add('mode-2');
            }



            // text表示判定用
            let heightBaseTextFadein = windowHeight*0.9;//ウインドウの中での位置・ほぼ固定
            let spanFadeIn = windowHeight*0.5;//60
            //.concept-content__scroll-bod[1]の高さが基準

            // bg0 テキスト
            // bg0 circleContainerのテキスト1行づつ表示 (baseY1に準ずる)
            // let bg0TextAll = document.querySelectorAll('.bg0 .texts')[0];
            // let bg0Texts = document.querySelectorAll('.bg0 .texts .text');

            // if(baseY1 < (heightBaseTextFadein - ((4*spanFadeIn))) ){
            //     bg0Texts[4].classList.add('is-show');
            //     //this.conceptCanvas.setExpandAnimMode(2);
            // }else{
            //     bg0Texts[4].classList.remove('is-show');
            // }

            // if(baseY1 < (heightBaseTextFadein - ((3*spanFadeIn))) ){
            //     bg0Texts[3].classList.add('is-show');
            // }else{
            //     bg0Texts[3].classList.remove('is-show');
            // }

            // if(baseY1 < (heightBaseTextFadein - ((2*spanFadeIn)))){
            //     bg0Texts[2].classList.add('is-show');
            // }else{
            //     bg0Texts[2].classList.remove('is-show');
            // }

            // if(baseY1 < (heightBaseTextFadein - ((1*spanFadeIn))) ){
            //     bg0Texts[1].classList.add('is-show');
            // }else{
            //     bg0Texts[1].classList.remove('is-show');
            // }

            // if(baseY1 < (heightBaseTextFadein) ){
            //     bg0Texts[0].classList.add('is-show');
            // }else{
            //     bg0Texts[0].classList.remove('is-show');
            // }

            // if(baseY1 > -200 ){//輪っかとタイミング合わせる
            //     bg0TextAll.classList.add('is-show');
            // }else{
            //     bg0TextAll.classList.remove('is-show');
            // }


            // bg0 ballExpand パラパラアニメ
            // console.log(baseY1);
            // if(baseY1 < (200) ){
            //     this.conceptCanvas.setExpandAnimMode(2);
            //     //ballsをフェードアウト
            //     document.querySelector('.index-concept').classList.add('concept-ball-anim-finished');
            // }else if(baseY1 < (heightBaseTextFadein - (1*60)) ){
            //     this.conceptCanvas.setExpandAnimMode(1);
            //     document.querySelector('.index-concept').classList.remove('concept-ball-anim-finished');
            // }else if(baseY1 < (heightBaseTextFadein)){
            //     this.conceptCanvas.setExpandAnimMode(0);
            // }




            // bg4 circleContainerのテキスト1行づつ表示 (baseY3に準ずる)
            // 231031 windowScrollY で判定に変更
            let bg4Texts = document.querySelectorAll('.bg4 .texts .text');

            if(windowScrollY > (100 + 1*spanFadeIn)){
                bg4Texts[0].classList.add('is-show');
            }else{
                bg4Texts[0].classList.remove('is-show');
            }
            if(windowScrollY > (100 + 2*spanFadeIn)){
                bg4Texts[1].classList.add('is-show');
            }else{
                bg4Texts[1].classList.remove('is-show');
            }
            if(windowScrollY > (100 + 3*spanFadeIn)){
                bg4Texts[2].classList.add('is-show');
            }else{
                bg4Texts[2].classList.remove('is-show');
            }
            if(windowScrollY > (100 + 4*spanFadeIn)){
                bg4Texts[3].classList.add('is-show');
            }else{
                bg4Texts[3].classList.remove('is-show');
            }
            if(windowScrollY > (100 + 5*spanFadeIn)){
                bg4Texts[4].classList.add('is-show');
            }else{
                bg4Texts[4].classList.remove('is-show');
            }
            // if(windowScrollY > (100 + 6*spanFadeIn)){
            //     bg4Texts[5].classList.add('is-show');
            // }else{
            //     bg4Texts[5].classList.remove('is-show');
            // }

            // bg4 輪っか
            if(baseY3 < (heightBaseTextFadein - (5*120)) ){
                circleContainer.classList.add('mode-4');
            }else{
                circleContainer.classList.remove('mode-4');
            }
            

            //-----------
            //concept-4, 円の拡大
            let con4 = document.querySelector('#cover-opening-circle .bg-circle');
            let calc4 = 1 - (scrollers[4].getBoundingClientRect().top/windowHeight*1.8);
            let clamp4 = this.clamp(calc4,1,3);
            //console.log(calc4 + ', ' + clamp4);
            let props4 = {
                'scale-wh': clamp4,
            }
            this.setProps(con4, props4);

            //concept-4, ボタン「OUR BRANDING」表示切り替え
            let baseY4 = scrollers[4].getBoundingClientRect().top;
            //let btnBranding  = document.getElementById('icon-large');
            //let skipBtn = document.querySelector('.index-concept-skip__container');
            let brandingBtn = document.querySelector('.index-link-branding__container');
            if(baseY4 < 0){
                //btnBranding.classList.add('hover');
                //skipBtn.classList.add('is-hide');
                brandingBtn.classList.add('is-hide');
            }else{
                //btnBranding.classList.remove('hover');
                //skipBtn.classList.remove('is-hide');
                brandingBtn.classList.remove('is-hide');
            }
            
            //concept終了
            if(document.getElementById('index-works')){
                if(document.getElementById('index-works').getBoundingClientRect().top < 0){
                    this.body.classList.add('concept-scrolled');
                    document.getElementById('side-ribbon').classList.add('bg-gray');
                }else{
                    this.body.classList.remove('concept-scrolled');
                    document.getElementById('side-ribbon').classList.remove('bg-gray');
                }
            }

            //flg
            //console.log(`conceptState=${conceptState}`);
            this.body.classList.add('flg-concept-'+(conceptState - 1));

            

        }

        // ===========
        // sticky風の動き（ブラウザ下端で止める）
        if (document.getElementById('js-index-content-container')) {
            let fixingSections = document.querySelectorAll('#index-brandingstyle,#index-works,#archive-works,#index-curation,#index-news');
            [].forEach.call(fixingSections, (elem) => {
                let bottomY = elem.getBoundingClientRect().bottom;
                if(bottomY <= windowHeight){
                    let transY = Math.round(0.7*(windowHeight - bottomY));
                    let props = {
                        'transy': transY,
                    }
                    this.setProps(elem, props);
                    //elem.classList.add('is-fixed--bottom');
                }else{
                    elem.style = null;
                    //elem.classList.remove('is-fixed--bottom');
                }
            });
        }


        // ===========
        // スクロール開始
        if (windowScrollY > 4) {
            this.body.classList.add('scrolled-title');
        } else {
            this.body.classList.remove('scrolled-title');
        }

        // ===========
        // inview判定
        this.inviewElems = document.querySelectorAll('.js-inview'); //複数
        //.js-inview に .inview 追加
        if (this.inviewElems.length !== 0) {
            //inviewElems = document.querySelectorAll('.js-inview');//複数
            [].forEach.call(this.inviewElems, (elem) => {
                //console.log(elem.classList);
                let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
                let y = clientRect.top; //画面の上端から、要素の上端までの距離
                //let elemY = window.pageYOffset + clientRect.top;// ページの上端から、要素の上端までの距離

                //表示タイミング ウインドウ上端から
                let showPos = windowHeight * 0.8;
                if (windowWidth > 600) {
                    showPos = windowHeight * 0.7; //pc
                }

                if (showPos > y && y > 0) {
                    elem.classList.add('inview');
                    // if (this.body.classList.contains('loaded')) {
                    //     elem.classList.add('inview');
                    // } else {
                    //     elem.classList.add('inview');
                    // }
                    if(elem.classList.contains('index-brandingstyle__fig-1')){
                        console.log(y + ', ' + elem.classList);
                        if(!elem.classList.contains('fig-anim-started')){
                            this.figAnim1(elem);
                        }
                    }
                }
            });
        }


        // ===========
        // worksスライダー(indexページ、worksページ)横移動
        if (document.getElementById('works-scrolling')) {

            // 全体
            let worksSlider = document.getElementById('works-scrolling');
            // スライダー
            let worksSliderContents = document.querySelector('.js-works-scroller-sidemove');
            
            //PCとTab横のみ（SPとTab縦は横スライド無効に）
            if(windowWidth > 700 && this.html.classList.contains('ratio-horisontal')){

                document.getElementById('works-scrolling').classList.remove('is-tablet-vertical--no-scroll');

                // スクロール実体
                let worksSliderScroller = document.querySelectorAll('.js-works-scroller-container .js-works-scroller');
                let scrollerHeight = worksSliderScroller[0].clientHeight;
                
                
                
                // スクロール最大量
                //let scrollMax = worksSliderScroller[0].clientHeight;
                
                // スクロール計算Y
                let scrollY = worksSliderScroller[0].getBoundingClientRect().top;

                // スクロール計算基準Y(スライダー高さ+Tab高さ)
                let baseY = worksSlider.querySelector('.is-sticky').clientHeight;

                // スクロールmin/max = stickyされる範囲
                let scrollMax = baseY;
                let scrollMin = baseY - scrollerHeight;

                // 0からmaxに調整し割合に変換
                let movePercent = 1 - 1*(scrollY - scrollMin)/(scrollMax - scrollMin);
                movePercent = this.clamp(movePercent, 0, 1);

                //let pd = 0;
                // if(windowWidth >= 1080){
                //     pd = 80 + (75 - 15)  + 60;// ribbon + スライダーの左pd + 右pd
                // }else{
                //     pd = 56 + 30;
                // }
                let pdLeftElem = document.getElementById('works-scrolling').querySelector('.works-feature');
                let pdLeft = parseInt(window.getComputedStyle(pdLeftElem, null).getPropertyValue('padding-left') || 0, 10);
                
                let pdRightElem = document.querySelector('.js-works-scroller-content');
                let pdRight = parseInt(window.getComputedStyle(pdRightElem, null).getPropertyValue('padding-left') || 0, 10);
                let rbnWidth = document.getElementById('side-ribbon').clientWidth;
                let pd = rbnWidth + pdLeft + pdRight - 15;//15は .works-feature__col のpadding-right


                // overflow:hiddenのせいかwidthが取れない?
                //console.log(worksSliderContents.clientWidth);
                let contentWidth = 3 * worksSliderContents.querySelector('.js-tab-content-feature.is-show .works-feature__col').clientWidth;
                //console.log(contentWidth, rbnWidth, pdLeft, pdRight);

                //横移動の量
                let moveXmax = contentWidth + pd - windowWidth;

                let transX = Math.round(moveXmax * movePercent);
                transX = this.clamp(transX, 0, contentWidth);

                //console.log(scrollY, scrollMin, scrollMax, movePercent, transX);

                let propsw = {
                    'transx': transX,
                }
                this.setProps(worksSliderContents, propsw);

            }else{
                worksSliderContents.style = null;
                document.getElementById('works-scrolling').classList.add('is-tablet-vertical--no-scroll');
            }

        }



        // ===========
        // memberスライダー横移動
        if (document.getElementById('member-scrolling')) {
            let memberSlider = document.getElementById('member-scrolling');

            // スライダー
            let memberSliderContents = document.querySelector('.js-member-scroller-sidemove');

            if(windowWidth > 700 && this.html.classList.contains('ratio-vertical')){
                //タブレット（縦長で幅700以上）では横スクロールしない
                memberSliderContents.style = null;
                memberSlider.classList.add('is-tablet-vertical--no-scroll');
            }else{
                memberSlider.classList.remove('is-tablet-vertical--no-scroll');

                // スクロール実体
                let memberSliderScroller = document.querySelectorAll('.js-member-scroller-container .js-member-scroller');
                let scrollerHeight = memberSliderScroller[0].clientHeight;
                
                // スクロール最大量
                //let scrollMax = memberSliderScroller[0].clientHeight;
                
                // スクロール計算Y
                let scrollY = memberSliderScroller[0].getBoundingClientRect().top;

                // スクロール計算基準Y
                let baseY = memberSlider.querySelector('.is-sticky').clientHeight;

                // スクロールYのmin/max = stickyされる範囲
                let scrollMax = baseY;
                let scrollMin = baseY - scrollerHeight;// - windowHeight;

                // スクロールYの量を(0からmaxに調整し)割合に変換
                let movePercent = 1 - 1*(scrollY - scrollMin)/(scrollMax - scrollMin);
                movePercent = this.clamp(movePercent, 0, 1);

                let pd = 0;
                if(windowWidth >= 1080){
                    pd = 15 + 65;
                }else if(windowWidth >= 700){
                    pd = 0;//tab スクロールせず
                }else{
                    pd = 32;//sp
                }

                let moveXmin = 0;
                let moveXmax = memberSliderContents.clientWidth - windowWidth + pd - 1;//増やすと多く移動する
                //let moveXmax = memberSliderContents.clientWidth + 0.5*pd + 1;//増やすと多く移動する
                let transX = Math.round(moveXmax * movePercent);
                transX = this.clamp(transX, moveXmin, moveXmax);

                //console.log(memberSliderContents.clientWidth, movePercent, moveXmax, transX, scrollY, scrollMin, scrollMax);

                let propsw = {
                    'transx': transX,
                }
                this.setProps(memberSliderContents, propsw);
            }
        }
       

        // ===========
        //  brandingページ: chart-1, chart-2 横移動
        // if (document.querySelectorAll('.js-chart-scrolling')[0]) {
        //     let charts = document.querySelectorAll('.js-chart-scrolling');
            
        //     [].forEach.call(charts, (chartSlider,index) => {
        //         //console.log(chartSlider);


        //         // スライダー
        //         let chartSliderAll = chartSlider.querySelector('.js-chart-scroller-sidemove');
        //         let csSingleWidth = chartSlider.querySelector('.js-chart-scroller-sidemove .branding-content__slide').offsetWidth;

        //         // スライダーのコンテンツ幅を計算（画面からはみ出すとcssの値が正常に出ない）
        //         let csAllWidth = 0;
        //         let csElems = chartSlider.querySelectorAll('.js-chart-scroller-sidemove .branding-content__slide');
        //         for(let i=0; i<=(csElems.length-1); i++){
        //             csAllWidth += csElems[i].offsetWidth;
        //         }

        //         // スクロール実体
        //         let scroller = chartSlider.querySelectorAll('.js-chart-scroller-container .js-chart-scroller');
        //         let scrollerHeight = scroller[0].clientHeight;

        //         // スクロール最大量
        //         //let scrollMax = scroller[0].clientHeight;
                
        //         // スクロール計算Y
        //         let scrollY = scroller[0].getBoundingClientRect().top;

        //         // スクロール計算基準Y(スライダー高さ+Tab高さ)
        //         let baseY = chartSlider.querySelector('.is-sticky').clientHeight;

        //         // スクロールYのmin/max = stickyされる範囲
        //         let scrollMax = baseY;
        //         let scrollMin = baseY - scrollerHeight;

        //         // スクロールYの量を(minからmaxに調整し)割合に変換
        //         let movePercent = 1 - 1*(scrollY - scrollMin)/(scrollMax - scrollMin);
        //         movePercent = this.clamp(movePercent, -0.5, 1.5);

        //         let pd = 0;
        //         if(windowWidth >= 1080){//1080
        //             pd = 80;//PC
        //         }else if(windowWidth >= 700){//700
        //             pd = 56;//tab
        //         }else{
        //             pd = 0;//sp
        //         }


        //         let moveXmin = -0.5*(windowWidth - csSingleWidth - pd);
        //         let moveXmax = csAllWidth - csSingleWidth - 0.5*(windowWidth - csSingleWidth - pd);//増やすと多く移動する
        //         let transX = Math.round(moveXmax * movePercent);
        //         transX = this.clamp(transX, moveXmin, moveXmax);

        //         if(index == 0){
        //             console.log('chart-'+index + ': ',movePercent, transX, scrollY, scrollMin, scrollMax, moveXmin, moveXmax);
        //         }

        //         let propsw = {
        //             'transx': transX,
        //         }
        //         this.setProps(chartSliderAll, propsw);


        //     });
        // }


        // ===========
        // brandingページ: step切り替え(v2309)
        if (document.getElementById('step-scroll-1')) {

            //tabの状態
            let stepState = 0;

            // スクロール基準
            let stepScrollChecker = document.getElementById('step-scroller-1');

            // 全体
            let stepScrolledElem = document.getElementById('step-scroll-1');

            // 表示コンテンツのグループ
            let showContents = document.querySelectorAll('#step-scroll-1 .step__slide');

            // 判定
            let clientRect = stepScrollChecker.getBoundingClientRect(); // 要素の位置座標
            let y = clientRect.top; //画面の上端から、要素の上端までの距離

            //切り替えタイミング ウインドウ上端から
            this.showPos1 = windowHeight * 0.4;
            this.showPos2 = windowHeight * -1.1;
            if (windowWidth > 600) {
                this.showPos1 = windowHeight * 0.3; //pc
                this.showPos2 = windowHeight * -1.1; //pc
            }

            //何番目を表示するか計算
            if (y < this.showPos2) {
                stepState = 2;
            }else if (y < this.showPos1) {
                stepState = 1;
            } 
            
            // 表示更新
            [].forEach.call(showContents, (elem, index) => {
                stepScrolledElem.classList.remove('step__slide--status-0');
                stepScrolledElem.classList.remove('step__slide--status-1');
                stepScrolledElem.classList.remove('step__slide--status-2');
                stepScrolledElem.classList.add('step__slide--status-'+stepState);

                if(index == stepState){
                    elem.classList.add('step__slide--is-show');
                }else{
                    elem.classList.remove('step__slide--is-show');
                }
            });

            //console.log('#step-scroll-1 show:'+stepState);
            
        }

        if (document.getElementById('step-scroll-2')) {

            //tabの状態
            let stepState = 0;

            // スクロール基準
            let stepScrollChecker = document.getElementById('step-scroller-2');

            // 全体
            let stepScrolledElem = document.getElementById('step-scroll-2');

            // 表示コンテンツのグループ
            let showContents = document.querySelectorAll('#step-scroll-2 .step__slide');

            // 判定
            let clientRect = stepScrollChecker.getBoundingClientRect(); // 要素の位置座標
            let y = clientRect.top; //画面の上端から、要素の上端までの距離

            //切り替えタイミング ウインドウ上端から
            this.showPos1 = windowHeight * 0.4;
            this.showPos2 = windowHeight * -1.1;
            if (windowWidth > 600) {
                this.showPos1 = windowHeight * 0.3; //pc
                this.showPos2 = windowHeight * -1.1; //pc
            }

            //何番目を表示するか計算
            if (y < this.showPos2) {
                stepState = 2;
            }else if (y < this.showPos1) {
                stepState = 1;
            } 
            
            // 表示更新
            [].forEach.call(showContents, (elem, index) => {
                stepScrolledElem.classList.remove('step__slide--status-0');
                stepScrolledElem.classList.remove('step__slide--status-1');
                stepScrolledElem.classList.remove('step__slide--status-2');
                stepScrolledElem.classList.add('step__slide--status-'+stepState);

                if(index == stepState){
                    elem.classList.add('step__slide--is-show');
                }else{
                    elem.classList.remove('step__slide--is-show');
                }
            });

            //console.log('#step-scroll-2 show:'+stepState);
            
        }


        // ===========
        // brandingページ: chart切り替え
        // if (document.getElementById('chart-scroller')) {
            
        //     if (document.getElementById('branding-tab')) {
        //         // tabボタンの表示: Tab縦,PCの時はtabボタンを画面内にsticky
        //         if((windowWidth > 700 && this.html.classList.contains('ratio-vertical')) || (this.html.classList.contains('ratio-horisontal'))){
        //             document.getElementById('branding-tab') .classList.add('is-sticky--tabs');
        //         }
        //     }

        //     //tabの状態
        //     let chartState = 0;

        //     // 全体
        //     let chartScrollChecker = document.getElementById('chart-scroller');

        //     // スクロール実体
        //     let chartScrolledElems = chartScrollChecker.querySelectorAll('.js-chart-scroller');

        //     // 表示コンテンツのグループ
        //     let showContents = document.querySelectorAll('.branding-content');

        //     // 判定
        //     [].forEach.call(chartScrolledElems, (elem) => {
        //         let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
        //         let y = clientRect.top; //画面の上端から、要素の上端までの距離

        //         //切り替えタイミング ウインドウ上端から
        //         let showPos = windowHeight * 0.4;
        //         if (windowWidth > 600) {
        //             showPos = windowHeight * 0.3; //pc
        //         }

        //         //何番目を表示するか
        //         if (y < showPos) {
        //             chartState += 1;
        //         }
        //     });

        //     let chart = document.querySelector('.branding-chart__header');
        //     chart.classList.remove('show-1');
        //     chart.classList.remove('show-2');
        //     chart.classList.remove('show-3');
        //     chart.classList.add('show-'+(chartState+1));

        //     //console.log('show:'+chartState);
            
        //     // 表示更新
        //     [].forEach.call(showContents, (elem) => {
        //         //console.log(elem);
        //         let targets = elem.querySelectorAll('.branding-content__slide');
        //         [].forEach.call(targets, (elem) => {
        //             elem.classList.remove('is-show');
        //         });
        //         targets[chartState].classList.add('is-show');
        //     });
        // }
    }

    // 初期化
    init() {
        smoothscroll.polyfill();
        this.inviewElems = document.querySelectorAll('.js-inview'); //複数
        
        // concept bg balls
        if(document.getElementById('conceptCanvas')){
            this.conceptCanvas = new Balls();
            this.conceptCanvas.init();


            // frame anim init
            this.conceptCanvas.playExpandAnimInit();
        }

        // branding-style btn sticky-1
        let bullets1 = document.querySelectorAll('#step-scroll-1 .step__slide-indicator .step__slide-indicator-circle');
        [].forEach.call(bullets1, (elem, index) => {
            elem.addEventListener('click', (event) => {
                event.preventDefault();

                let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
                let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);

                //切り替えタイミング ウインドウ上端から
                this.showPos1 = windowHeight * 0.4;
                this.showPos2 = windowHeight * -1.1;
                if (windowWidth > 600) {
                    this.showPos1 = windowHeight * 0.3; //pc
                    this.showPos2 = windowHeight * -1.1; //pc
                }

                let stepScrollChecker = document.getElementById('step-scroller-1');
                let clientRect = stepScrollChecker.getBoundingClientRect();
                let y = clientRect.top;
                let targetTopY = 0;

                if(index == 0){
                    targetTopY = window.scrollY + y - windowHeight;
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                if(index == 1){
                    targetTopY = window.scrollY + y + Math.abs(this.showPos1);
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                if(index == 2){
                    targetTopY = window.scrollY + y + Math.abs(this.showPos2) + 10;
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                //console.log(index, y0, y1, y2);
            });
        });

         // branding-style btn sticky-2
         let bullets2 = document.querySelectorAll('#step-scroll-2 .step__slide-indicator .step__slide-indicator-circle');
         [].forEach.call(bullets2, (elem, index) => {
             elem.addEventListener('click', () => {
                event.preventDefault();

                let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
                let windowHeight = (window.innerHeight || document.documentElement.clientHeight || 0);

                //切り替えタイミング ウインドウ上端から
                this.showPos1 = windowHeight * 0.4;
                this.showPos2 = windowHeight * -1.1;
                if (windowWidth > 600) {
                    this.showPos1 = windowHeight * 0.3; //pc
                    this.showPos2 = windowHeight * -1.1; //pc
                }

                let stepScrollChecker = document.getElementById('step-scroller-2');
                let clientRect = stepScrollChecker.getBoundingClientRect();
                let y = clientRect.top;
                let targetTopY = 0;

                if(index == 0){
                    targetTopY = window.scrollY + y - windowHeight;
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                if(index == 1){
                    targetTopY = window.scrollY + y + Math.abs(this.showPos1);
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                if(index == 2){
                    targetTopY = window.scrollY + y + Math.abs(this.showPos2) + 10;
                    //window.scrollTo(0,targetTopY);
                    window.scroll({
                        top: targetTopY,
                        behavior: 'smooth'
                    });
                }
                //console.log(index, y0, y1, y2);
             });
         });
 

    }
}